import { INotification } from 'src/@types/apiResponse';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

const SUB_URL = '/notif';

/** 푸시 알림 조회 */
export const getNotification = async () => {
  try {
    const url = `${SUB_URL}`;

    const response = await instance.get<TApiResponseData<INotification[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const markAsRead = async () => {
  try {
    const url = `${SUB_URL}/read`;
    const response = await instance.post<TApiResponseData<INotification[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
